var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app-layout" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showFilters && _vm.servicesView == "map",
              expression: "( !showFilters && servicesView == 'map' )",
            },
          ],
          staticClass: "show-filters",
          on: {
            click: function ($event) {
              return _vm.toggleShowFilters()
            },
          },
        },
        [_c("img", { attrs: { src: "/img/grey-right.svg" } })]
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("FlashMessage", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.flashMessage,
                expression: "flashMessage",
              },
            ],
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("navigation"),
      _vm._v(" "),
      _c("router-view"),
      _vm._v(" "),
      _c("info-modal"),
      _vm._v(" "),
      _c("contact-modal"),
      _vm._v(" "),
      _c("filters"),
      _vm._v(" "),
      _c("pop-out"),
      _vm._v(" "),
      _c("switch-type-modal"),
      _vm._v(" "),
      _c("cancel-scenario-modal", {
        attrs: {
          show: _vm.showCancelScenarioModal,
          "cancel-token": _vm.$route.query.st,
        },
        on: { "close-modal": _vm.closeCancelScenarioModal },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }